<template>
  <div class="app-side">
    <div class="menuList">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#fff"
        text-color="#555555"
        active-text-color="#409EFF"
      >
        <el-menu-item index="1" @click="homePage">首页</el-menu-item>
        <el-menu-item index="2">产融供应链</el-menu-item>
        <el-menu-item index="3">产融科技</el-menu-item>
        <el-menu-item index="4">产融大数据</el-menu-item>
        <el-menu-item index="5">数字产业聚集区</el-menu-item>
        <el-submenu index="9" class="xia">
          <template slot="title">产业解决方案</template>
          <el-menu-item class="xaila" index="9-1"><i class="el-icon-s-help"></i> 再生资源</el-menu-item>
          <el-menu-item class="xaila" index="9-2"><i class="el-icon-menu"></i> 建材砂石</el-menu-item>
        </el-submenu>
        <el-menu-item index="6">阳光购销</el-menu-item>
        <el-menu-item index="7">关于</el-menu-item>
        <el-menu-item index="8">入驻流程</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "appSide",
  data() {
    return {
      activeIndex: "1",
    };
  },
  watch: {
    $route(newVal) {
      const key = newVal.path;
      if (key === "/") {
        this.activeIndex = "1";
      } else if (key === "/CrSupplyChain") {
        this.activeIndex = "2";
      } else if (key === "/CrTechnology") {
        this.activeIndex = "3";
      } else if (key === "/CrBigData") {
        this.activeIndex = "4";
      } else if (key === "/SzcyGatheringArea") {
        this.activeIndex = "5";
      } else if (key === "/YgPurchaseAndSale") {
        this.activeIndex = "6";
      } else if (key === "/About") {
        this.activeIndex = "7";
      } else if (key === "/ApplicationProcess") {
        this.activeIndex = "8";
      } else if (key === "/newResources") {
        this.activeIndex = "9-1";
      } else if (key === "/buildingMaterialsSand") {
        this.activeIndex = "9-2";
      }
    },
  },
  methods: {
    handleSelect(key) {
      if (key === "1") {
        this.$router.push("/");
      } else if (key === "2") {
        this.$router.push("/CrSupplyChain");
      } else if (key === "3") {
        this.$router.push("/CrTechnology");
      } else if (key === "4") {
        this.$router.push("/CrBigData");
      } else if (key === "5") {
        this.$router.push("/SzcyGatheringArea");
      } else if (key === "6") {
        this.$router.push("/YgPurchaseAndSale");
      } else if (key === "7") {
        this.$router.push("/About");
      } else if (key === "8") {
        this.$router.push("/ApplicationProcess");
      } else if (key === "9-1") {
        this.$router.push("/newResources");
      } else if (key === "9-2") {
        this.$router.push("/buildingMaterialsSand");
      }
    },
    homePage() {},
  },
};
</script>

<style lang="scss" scoped>
.scroll-content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.menuHome {
  /*font-size: 18px;*/
  color: #606266;
}

.app-side {
  width: 100%;
  height: 100%;
}

.el-menu-item:hover {
  color: rgb(64, 158, 255) !important;
  background-color: #fff !important;
}

.el-menu-item.is-active {
  height: 100%;
}

.el-menu--horizontal > .el-menu-item {
  height: 70px;
  line-height: 70px;
  padding: 0px 10px;
}
/deep/.el-submenu__title:hover {
  color: rgb(64, 158, 255) !important;
  background-color: #fff !important;
}
/deep/.el-submenu__title .el-menu-item {
  text-align: center;

}
/deep/.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 70px;
  line-height: 70px;
}
.el-menu.el-menu--horizontal {
  width: 100%;
  border-bottom: none;
  display: flex;
  justify-content: space-around;
}

.image {
  vertical-align: middle;
  margin-bottom: 2px;
}
</style>
